'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isNumeric;
/**
 * Check if a value is numeric
 *
 * @param param Value to be checked
 * @returns {boolean} Returns true when the `param` is a numeric value
 */
function isNumeric(param) {
    if ((typeof param === 'undefined' ? 'undefined' : _typeof(param)) === 'symbol') {
        return false;
    }

    return !isNaN(parseFloat(param)) && global.isFinite(param);
}
//# sourceMappingURL=isNumeric.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/~/d2-utilizr/lib/isNumeric.js
 ** module id = 18
 ** module chunks = 0 1
 **/